import React from 'react';
import { Empty, Typography } from 'antd';

const { Text } = Typography;

const EmptyState = ({ message = 'No data found', hint }) => (
  <Empty
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    description={
      <span>
        <Text strong>{message}</Text>
        {hint && (
          <>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>{hint}</Text>
          </>
        )}
      </span>
    }
    style={{ padding: '32px 0' }}
  />
);

export default EmptyState;
